import { h } from 'preact';
import { Text } from 'preact-i18n';
import style from './style';
import cx from 'classnames';

export default function LoadingText({ color, ...props }) {
	return (
		<span {...props} class={cx(style.loading, style[color], props.class)}>
			<Text id="loading" />
		</span>
	);
}
